// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1q23N","search":"Settings_search__10VQ_","filter":"Settings_filter__TH5ak"};